var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPetAltVet = function SvgPetAltVet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5228 19.6434C16.6766 19.6434 8.44686 28.6812 8.44686 34.3897C8.38205 36.9604 10.3517 38.4998 13.6692 38.4998C17.2637 38.4998 19.6428 36.651 22.5228 36.651C25.4323 36.651 27.8188 38.4998 31.3765 38.4998C34.6248 38.4998 36.6607 36.9618 36.6607 34.3934C36.5988 28.6886 28.3713 19.6434 22.5228 19.6434Z",
    fill: "#FF7342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6806 18.7156C10.9167 16.1655 8.55013 14.5082 6.40522 15.0238C4.26031 15.5394 3.14336 18.0232 3.90749 20.5717C4.67132 23.1276 7.03794 24.7849 9.18285 24.2693C11.3278 23.7537 12.4393 21.2641 11.6806 18.7156ZM17.9194 17.1835C20.1932 16.585 21.3349 13.5669 20.4606 10.3061C19.5863 7.04523 17.0355 5.069 14.7528 5.60154C12.479 6.20001 11.3373 9.21813 12.2117 12.479C13.0874 15.6735 15.636 17.7875 17.9194 17.1835ZM38.6466 15.0253C36.5017 14.576 34.1351 16.167 33.3713 18.717C32.6075 21.2678 33.7212 23.753 35.8661 24.2686C38.011 24.7179 40.368 23.1269 41.1414 20.5769C41.9023 18.0232 40.7238 15.5409 38.6466 15.0253ZM27.1266 17.1835C29.3437 17.7819 31.96 15.6735 32.8343 12.479C33.7086 9.28443 32.5673 6.19964 30.2931 5.60154C28.076 5.00307 25.4597 7.11152 24.5854 10.3061C23.7089 13.5006 24.8506 16.5868 27.1266 17.1835Z",
    fill: "#FF7342"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPetAltVet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pet-alt-vet.614c14bc.svg";
export { ForwardRef as ReactComponent };